.tab-panel {
    display: none;
    background-color: #ffffff;
  }
  
  .tab-panel.active {
    display: block;
  }
  

  